var map = {
	"./A2A-introduce.svg": 90440,
	"./accountant-introduce.svg": 73833,
	"./customer-introduce.svg": 63027,
	"./inquiry-introduce.svg": 88078,
	"./ipg-introduce.svg": 41572,
	"./kerdar-introduce.svg": 16192,
	"./requestMoney-introduce.svg": 59208,
	"./settlement_batch-introduce.svg": 38780,
	"./subscription-introduce.svg": 95434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48545;